/**
 * Hardcoded CMS content previously served from Contentful (master environment).
 * Source: content_type=cmaListing and content_type=portalHolidayListing
 * Last synced: 2026-01-19
 */

export const holidayBanner = {
  'en-US': {
    date: '23-07-2026',
    title: 'Upcoming Holiday: Early Closure on 23 July',
    country: ['US'],
    subtitle:
      'Please note that our Operations team will be available only until 10:00 AM ET (7:30 PM IST) on July 23 due to a holiday. Any funding requests received after this time will be processed on the next business day.',
    writtenby: '- Team Drip Capital'
  },
  'es-ES': {
    date: '3-08-2024',
    title:
      'Este es un escenario de caso de prueba para el servidor provisional.',
    country: ['India', 'Mexico'],
    subtitle:
      'Por favor ignore este mensaje. Ya que solo se considera para el entorno de puesta en escena. Para obtener más detalles, consulte contentful.com en español.',
    writtenby: 'Equipo Dripcapital'
  }
}

export const bankHolidays = {
  US: {
    title: 'US BANK HOLIDAY LIST',
    subtext:
      'NOTE : OUR PARTNER BANKS WILL BE CLOSED ON THESE DAYS. ALL ADVANCES, SETTLEMENTS, AND BANK COVER LETTER APPLICATIONS WILL BE PROCESSED ON THE NEXT WORKING DAY.',
    fields: ['HOLIDAY', 'DAY', 'DATE'],
    list: [
      { holiday: 'New Year', date: 'January 1st, 2026' },
      { holiday: 'MLK Day', date: 'January 19th, 2026' },
      { holiday: "President's Day", date: 'February 16th, 2026' },
      { holiday: 'US Memorial Day', date: 'May 25th, 2026' },
      { holiday: 'Juneteenth', date: 'June 19th, 2026' },
      { holiday: 'Independence Day', date: 'July 3rd, 2026' },
      { holiday: 'US Labor Day', date: 'September 7th, 2026' },
      { holiday: 'Columbus Day', date: 'October 12th, 2026' },
      { holiday: 'Veterans Day', date: 'November 11th, 2026' },
      { holiday: 'US Thanksgiving', date: 'November 26th, 2026' },
      { holiday: 'Christmas', date: 'December 25th, 2026' }
    ]
  },
  IN: {
    title: 'INDIA BANK HOLIDAY LIST',
    subtext:
      'NOTE : DRIP CAPITAL WILL BE CLOSED ON THESE DAYS. ALL ADVANCES, SETTLEMENTS, AND BANK COVER LETTER APPLICATIONS WILL BE PROCESSED ON THE NEXT WORKING DAY.',
    fields: ['HOLIDAY', 'DAY', 'DATE'],
    list: [
      { holiday: 'New Year', date: 'January 1st, 2026' },
      { holiday: 'Republic Day', date: 'January 26th, 2026' },
      { holiday: 'Holi', date: 'March 4th, 2026' },
      { holiday: 'Ramzaan Eid', date: 'March 20th, 2026' },
      { holiday: 'Good Friday', date: 'April 3rd, 2026' },
      { holiday: 'Maharashtra Day', date: 'May 1st, 2026' },
      { holiday: 'Bakri Eid', date: 'May 27th, 2026' },
      { holiday: 'Independence Day', date: 'August 26th, 2026' },
      { holiday: 'Ganesh Chaturthi', date: 'September 14th, 2026' },
      { holiday: 'Gandhi Jayanti', date: 'October 2nd, 2026' },
      { holiday: 'Diwali', date: 'November 9th, 2026' },
      { holiday: 'Christmas', date: 'December 25th, 2026' }
    ]
  },
  MX: {
    title: 'MEXICO BANK HOLIDAY LIST',
    subtext:
      'Note : DRIP CAPITAL WILL BE CLOSED ON THESE DAYS. ALL ADVANCES, SETTLEMENTS, AND BANK COVER LETTER APPLICATIONS WILL BE PROCESSED ON THE NEXT WORKING DAY.',
    fields: ['HOLIDAY', 'DAY', 'DATE'],
    list: [
      { holiday: 'New Year', date: 'January 1st, 2026' },
      { holiday: 'Constitución Mexicana', date: 'February 2nd, 2026' },
      {
        holiday: 'Benito Juarez Birthday Memorial',
        date: 'March 16th, 2026'
      },
      { holiday: 'Good Friday', date: 'April 3rd, 2026' },
      { holiday: 'Labour Day', date: 'May 1st, 2026' },
      { holiday: 'Independence Day', date: 'September 16th, 2026' },
      { holiday: 'Revolution day', date: 'November 16th, 2026' },
      { holiday: 'US Thanksgiving', date: 'November 26th, 2026' },
      { holiday: 'Christmas', date: 'December 25th, 2026' }
    ]
  }
}
